import {
  Component,
  EventEmitter,
  Input,
  Output,
  ViewChildren,
} from '@angular/core';
import { CommonService } from 'src/@services/common.service';
import { FormService } from 'src/@services/form.service';
import { ResponseStatus } from 'src/@shared/enum';
import { QBOEnvironment } from 'src/environments/environment';
import { CommonPagesService } from '../../../common-pages.service';

@Component({
  selector: 'app-add-update-refund',
  templateUrl: './add-update-refund.component.html',
  styleUrls: ['./add-update-refund.component.scss'],

  standalone: false,
})
export class AddUpdateRefundComponent {
  isVisibleRefundModal: any = true;
  refundDetails: any;
  balanceAmount: any;
  netAmount: any;
  isLoadingPrograms: any = false;
  isLoadingRefundDetails: any = false;
  listOfProgramPeriods: any;
  isLoadingRefund: any;
  isLoadingTags: any = false;
  selectedTag: any;
  listOfTags: any = [];
  selectedTagGroup: any = '';
  @Output() hideRefundDrawer = new EventEmitter();
  @Input() selectedData: any;
  qboURL = QBOEnvironment.URL;
  isResyncingData: boolean = false;
  constructor(
    public _cS: CommonService,
    private _cpS: CommonPagesService,
    public _fS: FormService
  ) {
    _fS.refundForm_fb();
  }
  ngOnInit(): void {
    this.getRefundDetails();
    // this.loadPrograms('');
  }

  handleCancel(data: any) {
    this.isVisibleRefundModal = false;
    this.hideRefundDrawer.emit({
      hide: this.isVisibleRefundModal,
      data: data,
    });
  }
  resynRefundData() {
    this.isResyncingData = true;
    this._cpS
      .resyncRefundData(this.selectedData.id)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          if (response.result.isRefundDeleted) {
            this._cS.displayMessage(
              'warning',
              'This transaction is deleted from QBO'
            );
            this.isResyncingData = false;
            this.handleCancel(response.result);
          } else {
            this.isResyncingData = false;
            this.refundDetails = response.result;
            this._cS.displayMessage('success', response.message);
          }
        } else {
          this.isResyncingData = false;
          this._cS.displayMessage('error', response.message);
        }
      });
  }
  siteDetails: any;
  getSiteDetails() {
    this._cpS
      .GetSiteDetails(this.refundDetails.siteId)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.siteDetails = response.result;
        }
      });
  }
  loadPrograms() {
    this.isLoadingPrograms = true;
    this._cpS.getProgramBySite(this.refundDetails.siteId).subscribe(
      (response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.isLoadingPrograms = false;
          this.listOfProgramPeriods = response.result;
          var defaultProgram = this.listOfProgramPeriods.find(
            (x: any) => x?.isDefault
          );
          if (this.selectedData == null) {
            this._fS.refundForm.patchValue({
              programPeriod: defaultProgram?.id,
            });
          }
        } else {
          this.listOfProgramPeriods = [];
          this.isLoadingPrograms = false;
          this._cS.displayMessage('error', response.message);
        }
      },
      (error: any) => {
        this.listOfProgramPeriods = [];
        this.isLoadingPrograms = false;
      }
    );
  }

  getRefundDetails() {
    this.isLoadingRefundDetails = true;
    this._cpS
      .GetRefundDetail(this.selectedData.id)
      .subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this.refundDetails = response.result;
          this._fS.refundForm.patchValue({
            programPeriod: this.refundDetails?.program?.id,
            isNonAlc: this.refundDetails?.isNonALC,
          });

          this.netAmount =
            this.refundDetails?.balanceTransferDetails?.amount -
            this.refundDetails?.balanceTransferDetails?.processingFee;
          this.loadPrograms();
          this.getSiteDetails();
          this.isLoadingRefundDetails = false;
        }
      });
  }

  checkTagGroupData(event: any) {
    var selectedGroup: any;
    var selectedTag: any;
    this.listOfTags.forEach((element: any) => {
      element.Tags.forEach((tag: any) => {
        if (tag._id == event) {
          selectedTag = tag;
          selectedGroup = element;
        }
      });
    });
    this.selectedTagGroup = selectedGroup;
    this.selectedTag = selectedTag?.Name;
  }

  updateRefund() {
    if (this._fS.refundForm.valid) {
      this.isLoadingRefund = true;
      var formValue = this._fS.refundForm.value;

      var selectedProgram = this.listOfProgramPeriods.find(
        (x: any) => x.id == formValue.programPeriod
      );
      var refundData = {
        id: this.selectedData.id,
        program: {
          id: formValue.programPeriod,
          name: selectedProgram.label,
        },
        isNonAlc: formValue.isNonAlc,
      };
      this._cpS.updateRefund(refundData).subscribe((response: any) => {
        if (response.responseStatus == ResponseStatus.success) {
          this._cS.displayMessage('success', response.message);
          //hide unit drawer

          this.isVisibleRefundModal = false;
          this.hideRefundDrawer.emit({
            hide: this.isVisibleRefundModal,
            data: null,
          });
          this.isLoadingRefund = false;
        } else {
          this._cS.displayMessage('error', response.message);
          this.isLoadingRefund = false;
        }
      });
    } else {
      //to fire validations on invalid fields
      this._cS.markFormGroupTouched(this._fS.refundForm);
    }
  }
}
